
    import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
    import api from "@/api";
    import store from "@/store";
    import { Message } from "element-ui";

    @Component({
        name: "list",
        components: {}
    })

    export default class extends Vue {
        // 字典
        config: any = store.state.system.config
        // 表格数据
        tableData = [];
        // 加载状态
        loading = false;
        // 总条数
        total = 0;
        // 搜索条件
        search = {
            keyword: '',
            type: '',
            created_at: [],
            pagination: {
                page: 0, //页码，从0开始
                pageSize: 10, //每页数量
            },
        };

        // 组织架构
        toDepartment(id: any) {
            this.$router.push({
                path: '/operate/department?op_id=' + id
            })
        }

        // 新建、配置
        ruleForm: any = {

        }
        date1: any = []
        editDialog = false
        btnloading = false
        add() {
            this.ruleForm = {}
            this.date1 = []
            this.editDialog = true
        }
        editO(row: any) {
            this.ruleForm = {
                id: row.id,
                name: row.name,
                type: row.type,
                start_at: row.start_at,
                end_at: row.end_at
            }
            this.date1 = [row.start_at, row.end_at]
            this.editDialog = true
        }
        cancle() {
            this.editDialog = false;

        }
        save() {
            if(!this.ruleForm.name) {
                this.$message.warning('请输入名称')
                return
            }
            if(!this.ruleForm.type) {
                this.$message.warning('请选择类型')
                return
            }
            if(this.date1.length == 0) {
                this.$message.warning('请选择有效期')
                return
            }

            this.ruleForm.start_at = this.date1[0]
            this.ruleForm.end_at = this.date1[1]
            this.btnloading = true;
            api.post(this.ruleForm.id ? 'A12003' : 'A12002', this.ruleForm).then(res => {
                this.$message.success('操作成功')
                this.searchTable()
                this.editDialog = false
            }).finally(() => {
                this.btnloading = false;
            })


        }

        //日志
        logDialog = false
        logTotal = 0
        logSearch = {
            id: '',
            pagination: {
                page: 0,
                pageSize: 20
            }
        }
        logTable = []
        toLog(id: any) {
            this.logSearch.id = id
            api.post('A12004', this.logSearch).then(res => {
                this.logTable = res.list
                this.logTotal = res.total
                this.logDialog = true
            })

        }

        // 搜索 search:true 重置翻页
        searchTable(search = false) {
            this.loading = true;
            if (search) {
                this.search.pagination = {
                    pageSize: 20,
                    page: 0,
                };
            }
            api
                .post("A12001", this.search)
                .then((data: any) => {
                    this.total = data.total;
                    this.tableData = data.list;
                })
                .finally(() => {
                    this.loading = false;
                });
        }

        activated() {
            this.searchTable();
        }
    }
